import { useNavigate } from "react-router-dom";

import "./Logout.css";

function Logout({ isLoggedIn }) {
  const navigate = useNavigate();

  if (!isLoggedIn) {
    return null;
  }

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <button
      type="button"
      className="logout-button"
      onClick={handleLogout}
      aria-label="Log out"
    >
      <img
        src="/assets/imgs/logout_icon.svg"
        alt=""
        className="img-button"
      />
    </button>
  );
}

export default Logout;
